import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  // Deep-link support: when the page loads with a hash (e.g. /#contact),
  // scroll to that section. Sections load async content, so their position
  // changes over time — we re-scroll periodically until the target position
  // is stable, or the user manually scrolls, or ~10s elapse.
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash === '#home') return;

    let lastY = null;
    let stableCount = 0;
    let elapsed = 0;
    const STEP_MS = 300;
    const MAX_MS = 10000;
    let userScrolled = false;

    // Stop re-scrolling if the user takes control
    const onUserScroll = () => { userScrolled = true; };
    window.addEventListener('wheel', onUserScroll, { passive: true });
    window.addEventListener('touchmove', onUserScroll, { passive: true });
    window.addEventListener('keydown', (e) => {
      if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(e.key)) {
        userScrolled = true;
      }
    });

    const tick = () => {
      if (userScrolled) return;
      const el = document.querySelector(hash);
      if (el) {
        const rect = el.getBoundingClientRect();
        const y = rect.top + window.scrollY;
        el.scrollIntoView({ behavior: elapsed === 0 ? 'auto' : 'smooth', block: 'start' });
        // Consider "stable" when the section top hasn't moved for ~2 seconds
        if (lastY !== null && Math.abs(y - lastY) < 4) {
          stableCount += 1;
          if (stableCount >= 6) return;
        } else {
          stableCount = 0;
        }
        lastY = y;
      }
      elapsed += STEP_MS;
      if (elapsed < MAX_MS) setTimeout(tick, STEP_MS);
    };

    // Small initial delay so first paint happens before we scroll
    const initial = setTimeout(tick, 50);
    return () => {
      clearTimeout(initial);
      window.removeEventListener('wheel', onUserScroll);
      window.removeEventListener('touchmove', onUserScroll);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <About />
      <Pricing />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
